import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import get from 'lodash/get';
import ProductTitle from 'yoda-site-components/lib/components/ProductTitle/ProductTitle';
import Messages, { messagesLevels } from 'yoda-site-components/lib/components/Messages';
import { selectDeviceType } from 'yoda-site-components/lib/selectors/ContextSelector';
import CouponExclusionBadge from 'yoda-site-components/lib/components/CouponExclusionBadge/CouponExclusionBadge';
import { productLotSelector } from 'yoda-site-components/lib/selectors/ProductPricingSelector';
import Link from 'yoda-site-components/lib/components/Link/Link';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import EnergyStar from '../../EnergyStar/EnergyStar';
import ProtectionPlan from '../BundleProtectionPlan/BundleProtectionPlan';
import ProductOptions from '../BundleProductOptions/BundleProductOptions';
import BundleChildImage from '../BundleChildImage/BundleChildImage';
import BundleProductNumber from '../BundleProductInfo/BundleProductNumber';
import BundleQuantity from '../BundleQuantity/BundleQuantity';
import BundleProductPricing from '../BundlePricing/BundleProductPricing';
import BundleEcoRebates from '../BundleEcoRebates/BundleEcoRebates';
import BundleDimensions from '../BundleDimensions/BundleDimensions';
import BundleChildDescription from './BundleChildDescription';
import {
    makeInitProductOption,
    selectSkuIdsForBundle,
} from '../../../selectors/Bundle/BundleProductOptionsSelector';
import * as styles from './BundleChildDetails.css';

const cx = classNames.bind(styles);

class BundleChildDetails extends Component {
    static propTypes = {
        bundleChildDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        deviceType: PropTypes.oneOfType([PropTypes.object]),
        deliveryDate: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        productOptions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        messages: PropTypes.oneOfType([PropTypes.object]),
        index: PropTypes.number.isRequired,
        selectedLotPrice: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        selectedSkuIds: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        featureFlags: PropTypes.oneOfType([PropTypes.object]),
    };

    static defaultProps = {
        bundleChildDetails: {},
        deviceType: {},
        deliveryDate: {},
        messages: {},
        productOptions: {},
        selectedLotPrice: {},
        selectedSkuIds: [],
        featureFlags: {},
    };

    messageToShow() {
        const { bundleChildDetails, deliveryDate } = this.props;
        let message = [];
        /* istanbul ignore next */
        if (Object.keys(deliveryDate).length > 0) {
            const zipCode = Object.keys(deliveryDate)[0];
            const deliveryProductDetails = deliveryDate[zipCode][bundleChildDetails.product.id];
            if (deliveryProductDetails) {
                const skuId = Object.keys(deliveryProductDetails)[0];
                const deliveryDetails = deliveryProductDetails[skuId];
                if (
                    !(
                        (deliveryDetails.available && deliveryDetails.earliestDeliveryDate) ||
                        deliveryDetails.isFetching
                    )
                ) {
                    message = [
                        {
                            id: `message_${bundleChildDetails.product.id}`,
                            type: 'error',
                            title: `This item is not available to ship to ${zipCode}`,
                        },
                    ];
                }
            }
        }
        return message;
    }

    render() {
        const {
            bundleChildDetails,
            deviceType,
            index,
            productOptions,
            messages,
            selectedLotPrice,
            selectedSkuIds,
            featureFlags: {
                removeLinkPrefix,
                displayCouponExclusions = true,
                enableWarrantySection,
            },
        } = this.props;
        const productID = bundleChildDetails.product.id;
        /* istanbul ignore next */
        const isEnergyStarAvailable = Object.keys(productOptions).length
            ? productOptions.selectedLotDetails.energyStar
            : false;

        const explorePackageStyle = dt([
            'sm:!px-0',
            'lg:py-10',
            'smMd:py-6',
            'border-b',
            'border-solid',
            'border-gray-25',
        ]);
        const bundleImageContainerStyle = dt([
            'smOnly:!p-0',
            'mdOnly:!py-0',
            'mdOnly:!pl-0',
            'mdOnly:!pr-2',
            'text-center',
            'relative',
            'lg:my-4',
            'lg:mx-auto',
            'lg:!p-0',
        ]);
        const smBundleImageContainerStyle = dt([
            'hidden',
            'smOnly:block',
            'smOnly:!p-0',
            'smOnly:text-center',
            'smOnly:mx-0',
            'smOnly:mb-4',
        ]);
        const productNumberStyle = dt([
            'text-small',
            'text-gray-60',
            'p-0',
            'lg:grid',
            'lg:p-0',
            'smMd:mb-2',
        ]);
        const productNumberDesktopStyle = dt([
            'text-small',
            'text-gray-60',
            'mb-4',
            'p-0',
            'grid',
            'lg:py-0',
        ]);

        return (
            <section data-attribute={index} data-automation-id="bundle-child" key={productID}>
                <div
                    className={`${cx(
                        'sm12',
                        'md12',
                        'lg12',
                        'xl12',
                        'explorePackage'
                    )} ${explorePackageStyle}`}
                >
                    {deviceType.isTablet ? (
                        <div
                            className={`${cx(
                                'sm12',
                                'md6',
                                'lg6',
                                'xl3',
                                'bundleImageContainer'
                            )} ${bundleImageContainerStyle}`}
                        >
                            <div className={cx('bundleChildImage')}>
                                <BundleChildImage
                                    productDetails={bundleChildDetails.product}
                                    index={index}
                                    dataAutomationId="bundle-product-image-block"
                                />
                                <EnergyStar energyStar={isEnergyStarAvailable} />
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                    {!deviceType.isDesktop ? (
                        <div
                            className={`${cx(
                                'sm12',
                                'md6',
                                'lg6',
                                'xl12',
                                'bundleDetailsContainer'
                            )} ${dt([
                                'lg:!p-0',
                                'lg:inline-table',
                                'smOnly:!px-0',
                                'mdOnly:!pl-2',
                                'mdOnly:!pr-0',
                            ])}`}
                        >
                            <div className={cx('bundleOptionsContainer', 'lg12', 'xl4')}>
                                <Messages
                                    className={cx('message')}
                                    level={messagesLevels.inline}
                                    messages={this.messageToShow()}
                                />
                                <div className={cx('productTitle')}>
                                    <ProductTitle
                                        className={cx('header-3')}
                                        dataAutomationId="bundle-product-title"
                                        title={bundleChildDetails.product.name}
                                    />
                                </div>
                                <div
                                    data-automation-id="productNumber"
                                    className={productNumberStyle}
                                >
                                    <span className={cx('productLink')}>
                                        {removeLinkPrefix ? (
                                            <Link
                                                href={bundleChildDetails.product.links.url}
                                                className={cx('productDescriptionLink')}
                                                removeLinkPrefix
                                            >
                                                View Full Details
                                            </Link>
                                        ) : (
                                            <a
                                                className={cx('productDescriptionLink')}
                                                href={bundleChildDetails.product.links.url}
                                            >
                                                View Full Details
                                            </a>
                                        )}
                                    </span>
                                    <BundleProductNumber
                                        productDetails={bundleChildDetails.product}
                                        index={index}
                                        productOptions={productOptions}
                                    />
                                </div>
                                <BundleProductPricing
                                    productDetails={bundleChildDetails.product}
                                    productOptions={productOptions}
                                    index={index}
                                />
                                {deviceType.isMobile ? (
                                    <div
                                        className={`${cx(
                                            'sm12',
                                            'md5',
                                            'lg4',
                                            'xl4',
                                            'bundleImageContainer',
                                            'smBundleImageContainer'
                                        )} ${smBundleImageContainerStyle}`}
                                    >
                                        <BundleChildImage
                                            productDetails={bundleChildDetails.product}
                                            index={index}
                                            dataAutomationId="bundle-product-image-block"
                                            productOptions={productOptions}
                                        />
                                        <EnergyStar energyStar={isEnergyStarAvailable} />
                                    </div>
                                ) : (
                                    ''
                                )}

                                <BundleEcoRebates
                                    automationId="ecorebates-block"
                                    uiContext="PDP"
                                    productDetails={bundleChildDetails.product}
                                    index={index}
                                    productOptions={productOptions}
                                />
                                {displayCouponExclusions ? (
                                    <CouponExclusionBadge
                                        couponExclusionMessage={
                                            selectedLotPrice.couponExclusionMessage
                                        }
                                    />
                                ) : null}
                            </div>
                            <div className={cx('lg12', 'xl5', 'bundleProductPricing')}>
                                <div className={cx('bundleproductOptionsContainer')}>
                                    <ProductOptions
                                        query={{ selectedSKUId: selectedSkuIds[index] }}
                                        productDetails={bundleChildDetails.product}
                                        automationId="product-dimensions-block"
                                        isBundle
                                        index={index}
                                        messages={messages}
                                        productOptions={productOptions}
                                    />
                                    <BundleQuantity
                                        productDetails={bundleChildDetails.product}
                                        index={index}
                                        messages={this.props.messages}
                                        productOptions={productOptions}
                                    />
                                    <div className={cx('bundleProtectionPlan')}>
                                        <ProtectionPlan
                                            productDetails={bundleChildDetails.product}
                                            index={index}
                                            protectionBundle
                                            dataAutomationId="bundle-protection-plan"
                                            productOptions={productOptions}
                                            messages={
                                                messages[
                                                    `PROTECTION_PLAN_MESSAGES_SECTION_${productID}`
                                                ]
                                            }
                                            enableWarrantySection={enableWarrantySection}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}

                    {deviceType.isDesktop ? (
                        <div className={cx('bundleDetailsContainer')}>
                            <div
                                className={`${cx(
                                    'bundleOptionsContainer',
                                    'sm4',
                                    'md4',
                                    'lg4',
                                    'xl4'
                                )} ${dt(['sm:!pl-0', 'sm:!pr-2.5'])}`}
                            >
                                <Messages
                                    className={cx('message')}
                                    level={messagesLevels.inline}
                                    messages={this.messageToShow()}
                                />
                                <div className={cx('productTitle')}>
                                    <ProductTitle
                                        className={`${cx('header-3')} ${dt(['leading-7'])}`}
                                        dataAutomationId="bundle-product-title"
                                        title={bundleChildDetails.product.name}
                                    />
                                </div>
                                <div
                                    data-automation-id="productNumberDesktop"
                                    className={productNumberDesktopStyle}
                                >
                                    <BundleProductNumber
                                        productDetails={bundleChildDetails.product}
                                        index={index}
                                        productOptions={productOptions}
                                    />
                                    <div className={cx('productLink')}>
                                        {removeLinkPrefix ? (
                                            <Link
                                                href={bundleChildDetails.product.links.url}
                                                className={cx('productDescriptionLink')}
                                                removeLinkPrefix
                                            >
                                                View Full Details
                                            </Link>
                                        ) : (
                                            <a
                                                className={cx('productDescriptionLink')}
                                                href={bundleChildDetails.product.links.url}
                                            >
                                                View Full Details
                                            </a>
                                        )}
                                    </div>
                                </div>
                                <BundleEcoRebates
                                    automationId="ecorebates-block"
                                    uiContext="PDP"
                                    productDetails={bundleChildDetails.product}
                                    index={index}
                                    productOptions={productOptions}
                                />
                                {displayCouponExclusions ? (
                                    <CouponExclusionBadge
                                        couponExclusionMessage={
                                            selectedLotPrice.couponExclusionMessage
                                        }
                                    />
                                ) : null}
                                <div className={cx('productDimensions')}>
                                    {deviceType.isDesktop &&
                                    bundleChildDetails &&
                                    bundleChildDetails.product &&
                                    bundleChildDetails.product.type !== 'REGULAR' ? (
                                        <BundleDimensions
                                            productDetails={bundleChildDetails.product}
                                        />
                                    ) : (
                                        ''
                                    )}
                                </div>
                                <div className={cx('productDescription')}>
                                    {deviceType.isDesktop &&
                                    bundleChildDetails &&
                                    bundleChildDetails.product &&
                                    bundleChildDetails.product.type === 'REGULAR' ? (
                                        <BundleChildDescription
                                            productDetails={bundleChildDetails.product}
                                            index={index}
                                        />
                                    ) : (
                                        ''
                                    )}
                                </div>
                            </div>
                            <div
                                className={`${cx(
                                    'sm3',
                                    'md3',
                                    'lg3',
                                    'xl3',
                                    'bundleImageContainer'
                                )} ${dt(['lg:!pl-1.5', 'lg:!pr-[23px]'])}`}
                            >
                                <>
                                    <BundleChildImage
                                        productDetails={bundleChildDetails.product}
                                        index={index}
                                        dataAutomationId="bundle-product-image-block"
                                        productOptions={productOptions}
                                    />
                                    <EnergyStar energyStar={isEnergyStarAvailable} />
                                </>
                            </div>
                            <div
                                className={`${cx(
                                    'sm5',
                                    'md5',
                                    'lg5',
                                    'xl5',
                                    'bundleProductPricing'
                                )} ${dt(['smOnly:!px-0', 'lg:!pl-[9px]', 'md:!py-0', 'md:!pr-0'])}`}
                            >
                                <BundleProductPricing
                                    productDetails={bundleChildDetails.product}
                                    productOptions={productOptions}
                                    index={index}
                                />
                                <div className={cx('bundleproductOptionsContainer')}>
                                    <ProductOptions
                                        query={{ selectedSKUId: selectedSkuIds[index] }}
                                        productDetails={bundleChildDetails.product}
                                        automationId="product-dimensions-block"
                                        isBundle
                                        index={index}
                                        messages={messages}
                                        productOptions={productOptions}
                                    />
                                    <BundleQuantity
                                        productDetails={bundleChildDetails.product}
                                        index={index}
                                        messages={this.props.messages}
                                        productOptions={productOptions}
                                    />
                                    <div className={cx('bundleProtectionPlan')}>
                                        <ProtectionPlan
                                            productDetails={bundleChildDetails.product}
                                            index={index}
                                            protectionBundle
                                            dataAutomationId="bundle-protection-plan"
                                            productOptions={productOptions}
                                            messages={
                                                messages[
                                                    `PROTECTION_PLAN_MESSAGES_SECTION_${productID}`
                                                ]
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                </div>
            </section>
        );
    }
}

const makeMapStateToProps = () => {
    const getInitProductOption = makeInitProductOption();
    const mapStateToProps = (state, ownProps) => ({
        productOptions: getInitProductOption(state, ownProps.index)[
            ownProps.bundleChildDetails.product.id
        ],
        deliveryDate: state.bundleDeliveryDate,
        deviceType: selectDeviceType(state),
        messages: state.messages,
        selectedLotPrice: productLotSelector(false)(state),
        selectedSkuIds: selectSkuIdsForBundle(state),
        featureFlags: get(state, 'context.featureFlags', {}),
    });
    return mapStateToProps;
};

export default connect(makeMapStateToProps)(BundleChildDetails);
